// Floating "Add feedback" launcher pill. Label is set via textContent (config strings are
// developer-provided, but we still never interpolate them into HTML).

export function createLauncher(shadow, cfg) {
  const wrap = document.createElement('div');
  wrap.className = 'ff';

  const btn = document.createElement('button');
  btn.className = 'ff-launcher';
  btn.type = 'button';
  btn.setAttribute('aria-label', cfg.label);

  const dot = document.createElement('span');
  dot.className = 'ff-dot';
  btn.appendChild(dot);
  btn.appendChild(document.createTextNode(cfg.label));

  wrap.appendChild(btn);
  shadow.appendChild(wrap);

  return {
    el: wrap,
    onClick(fn) { btn.addEventListener('click', fn); },
    hide() { wrap.classList.add('ff-hidden'); },
    show() { wrap.classList.remove('ff-hidden'); },
  };
}
